import pluginId from './pluginId';
import Initializer from './components/Initializer';
export default {
  register(app) {
    app.registerPlugin({
      id: pluginId,
      initializer: Initializer,
      isReady: false
    });
  }
};